import { combineReducers } from "redux";
import { UIReducer } from "./UIReducer";
import { licenseValidityReducer } from "./LicenseValidityReducer";
import { warningReducer } from "./warningReducer";
import { licenseReducer } from "../Components/License/state/reducer";
import { adminLicenseReducer } from "../Components/Admin/License/state/reducer";
import { adminChangeRequestsReducer } from "../Components/Admin/ChangeRequests/state/reducer";

import {
  archivalManagementReducer,
  bankSettingsReducer,
} from "../Components/AdminTool/state/reducers";
import {
  swiftDayReducer,
  swiftMessagesReducer,
} from "../Components/Swift/state/reducers";
import { adminAlertReducer } from "../Components/AdminTool/state/reducers";
import { reportingReducer } from "../Components/Reporting/state/reducers";
import {
  internalAlertReducer,
  FollowingOnInternalAlertsReducer,
  FollowingOnInternalNotificationReducer,
  CustomerList,
  CustomersGroups,
} from "../Components/Alerts/state/alertReducer";
import {
  MatchingDayReducer,
  MatchingRulesReducer,
} from "../Components/Mathcing/state/matchingReducer";

const rootReducer = combineReducers({
  UI: UIReducer,
  licenseValidity: licenseValidityReducer,
  warning: warningReducer,
  license: licenseReducer,
  adminLicense: adminLicenseReducer,
  adminChangeRequests: adminChangeRequestsReducer,
  archivalManagement: archivalManagementReducer,
  bankSettings: bankSettingsReducer,
  swiftDay: swiftDayReducer,
  swiftMessages: swiftMessagesReducer,
  alertAndNotifications: adminAlertReducer,
  internalAlertRules: internalAlertReducer,
  FollowingOnInternalAlerts: FollowingOnInternalAlertsReducer,
  reporting: reportingReducer,
  FollowingOnInternalNotification: FollowingOnInternalNotificationReducer,
  CustomerList: CustomerList,
  CustomersGroups: CustomersGroups,
  matchingDay: MatchingDayReducer,
  matchingRules: MatchingRulesReducer,
});

const allReducers = (state, action) => {
  const { type } = action;

  switch (type) {
    default:
      return rootReducer(state, action);
  }
};

export default allReducers;
